<template>
    <table class="table is-fullwidth">
        <tbody>
            <tr>
            <th class="is-uppercase is-size-6 has-padding-left-0-5 ">Notizen</th>
            <th class="has-text-right">
                <button class="button is-small is-primary" @click="showForm">
                    <span class="has-margin-right-0-5" v-if="!toggleForm">Neue Notiz</span>
                    <span class="has-margin-right-0-5" v-if="toggleForm">Formular schließen</span>
                    <i v-if="!toggleForm" class="fa fa-plus" title="Formular öffnen"></i>
                    <i v-if="toggleForm" class="fa fa-minus" title="Formular schließen"></i>
                </button>
            </th>
            </tr>
            <tr v-if="toggleForm">
                <td>
                    <div class="form">
                        <div class="field is-horizontal">
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <textarea class="textarea" aria-label="Notiz" v-model="text" value="">
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="field">
                        <div class="control">
                                    <button :class="(loading) ? 'button is-primary is-loading' : 'button is-primary'" @click="submitForm">
                                    Erstellen
                                    </button>
                                </div>
                    </div>
                </td>
            </tr>
            <tr v-if="toggleEditForm">
                <td>
                    <div class="form">
                        <div class="field is-horizontal">
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <textarea class="textarea" aria-label="Notiz" v-model="edittext" value="">
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="field">
                        <div class="control">
                                    <button :class="(loading) ? 'button is-primary is-loading' : 'button is-primary'"  @click="submitEditedModel(editid)">
                                    Änderung speichern
                                    </button>
                                </div>
                    </div>
                </td>
            </tr>
            <tr>
                <th class="is-uppercase is-size-7 is-borderless">Notiz</th>
                <th class="is-uppercase is-size-7 is-borderless">Datum</th>
            </tr>
            <tr v-for="note in notes" v-bind="notes">
                <td class="is-width-75">{{ note.text }}</td>
                <td>{{ note.created_at }}
                    <button :class="(loading) ? 'button is-small is-loading' : 'button is-small'" @click="deleteModel('notes', note.id)"><i class="fa fa-minus"></i></button>
                    <button :class="(loading) ? 'button is-small is-loading' : 'button is-small'" @click="editModel(note, note.id)"><i class="fa fa-edit"></i></button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'
Vue.use(VueEvents)

export default {
    components: {},
    beforeMount: function () {
    },
    props: ['model', 'playerid', 'playernotes'],
    data: function() {
        return {
            loading: false,
            toggleForm: false,
            toggleEditForm: false,
            text: '',
            edittext: '',
            editid: null,
            notes: JSON.parse(this.playernotes),
            removeQuestionPart: 'die Notiz'
        }
    },
    methods: {
      submitForm() {
          this.loading = true;
          axios.post(`/${this.model}/new/${this.playerid}`, {
              text: this.$data.text
          }).then(res => {
              this.loading = false;
              this.notes.unshift(res.data)
              this.toggleForm = false;
              this.$data.text = '';
            })
        },
        showForm() {
            this.$data.toggleEditForm = false;
            this.$data.toggleForm = !this.$data.toggleForm;
        },
        editModel (model, modelid) {
            this.$data.toggleForm = false;
            this.$data.editid = modelid;
            this.$data.edittext = model.text
            this.toggleEditForm = true
        },
        submitEditedModel(modelid) {
            this.loading = true;
            axios.put(`/${this.$props.model}/${modelid}`, {
                text: this.$data.edittext
            }).then(res => {
                console.log(res.data)
                this.$data.loading = false;
                this.$data.edittext = '';
                this.$data.editid = '';

                this.$data.notes.forEach((element, index) => {
                    if(element.id === res.data.id) {
                        this.$data.notes[index] = res.data;
                    }
                });

                this.$data.toggleEditForm = false;

            }).catch(err => {
                this.$data.loading = false;
                console.log(err);
            })
        },
        deleteModel (model, modelid) {

          if(confirm(`Sicher, dass Sie ${this.removeQuestionPart} entfernen möchten?`)) {
            this.$data.loading = true;
            axios.delete(`/${model}/${modelid}`).then(res => {
              console.log(res);
              this.$data.loading = false;
              this.notes = this.notes.filter(note => {
                  return note.id !== modelid;
              })
            }).catch(err => {
                console.log(err)
                this.$data.loading = false;
            })
          }
        }
  }

}
</script>

<style>
    .is-width-75 {
        width: 75%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Players/Notes.vue